<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
        <div>
          <el-card class="NumberCardWidth">
            <div class="deal flex-between">
              <div class="card-text">
                <h3>心愿清单</h3>
              </div>
              <div class="card-button">
                <el-button class="push-button" @click="NvagetToLookMenber" icon="iconfont icon-fanhui" plain
                  >返回基本信息</el-button
                >
              </div>
            </div>
            <div class="NumberTable">
              <!-- table列表 -->
              <Table
                 @TouchTheBottom="TouchTheBottom"
                :PagesData="paging"
                :tableData="list.tbody"
                :configTable="list.thead"
                :config="list"
              ></Table>
            </div>
          </el-card>
        </div>
        <!-- 右侧列表相关链接 -->
        <!-- 使用封装的组件 -->
        <div class="PagesContentRight">
          <RightCard></RightCard>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetQueryCustWishList } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages:2,
        Loading:true
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "客户卡号",
            prop: "cardNo",
          },
          {
            label: "客户姓名",
            prop: "custName"
          },
          {
            label: "意向款号",
            prop: "wishProduct"
          },
          {
            label: "首次购买销售单",
            prop: "firstSaleNo",
             width: 150,
          },
          {
            label: "创建人",
            prop: "createUser",
            width: 120,
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 200,
          },
          {
            label: "最后修改人",
            prop: "updateUser",
             width: 120,
          },
          {
            label: "修后修改时间",
            prop: "updateTime",
            width: 200,
          },
        ],
        tbody: [],
      },
    };
  },
  created() {
    this.RGetQueryCustWishList();
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  methods: {
    TouchTheBottom() {
      this.paging.page++;
      this.RGetQueryCustWishList();
    },
    RGetQueryCustWishList() {
      let data = require('qs').stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetQueryCustWishList(data).then((res) => {
        if (res.success == true) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
          });
          this.list.tbody =this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false
      });
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    }
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth{
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
   margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
